module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"RatingTable":null}}')
  delete Component.options._Ctor
}
